import { ServiceDetailType } from './ServiceDetails.js';

class ServiceDetailsMapper {
  static createFromResponse(response) {
    return {
      [ServiceDetailType.DETAILS]: response[ServiceDetailType.DETAILS] || undefined,
      [ServiceDetailType.INFO]: response[ServiceDetailType.INFO] || undefined
    };
  }
}

export { ServiceDetailsMapper };
//# sourceMappingURL=ServiceDetailsMapper.js.map
